module.exports = __webpack_public_path__ + "img/hk.98d52d17.svg";